import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-312685e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mfa-page" }
const _hoisted_2 = { class: "secret-container display-text" }

import { computed, ref } from 'vue'
import { faKey } from 'fontawesome/free-solid-svg-icons'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { sleep } from '@/utils/async'
import { Clipboard } from '@capacitor/clipboard'
import BasePillButton from '@/components/BasePillButton.vue'
import SimpleSpinner from '@/components/SimpleSpinner.vue'

interface Props {
    formattedTime: string
    secret: string
    isVerifying: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MFAValidation',
  props: {
    formattedTime: { default: '' },
    secret: { default: '' },
    isVerifying: { type: Boolean, default: false }
  },
  emits: ['verifyMFA'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(false)
const copied = ref(false)
const verificationCode = ref('')

const copyText = computed(() => {
    return copied.value ? 'Copied to Clipboard' : 'Copy to Clipboard'
})

const enteredCode = computed(() => {
    return !!verificationCode.value
})

async function verifyMFA() {
    emit('verifyMFA', verificationCode.value)
}

function resetMFAInput() {
    verificationCode.value = ''
}

async function copyToClipboard() {
    const secretToCopy = document.getElementsByClassName(
        'secret-container'
    )[0] as HTMLInputElement

    // copy Link
    await Clipboard.write({
        string: secretToCopy.innerText.trim(),
    })

    copied.value = true
    await sleep(2000)
    copied.value = false
}

__expose({
    resetMFAInput,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FontAwesomeIcon), {
      class: "key-icon",
      icon: _unref(faKey)
    }, null, 8, ["icon"]),
    _createVNode(Typography, {
      variant: "h4",
      component: "h4",
      class: "title-container"
    }, {
      default: _withCtx(() => [
        _createTextVNode("The Secret Key")
      ], undefined, true),
      _: 1
    }),
    _createVNode(Typography, {
      variant: "body2",
      class: "detail-container"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Please enter the secret key below into your preferred MFA app. The secret key will expire in " + _toDisplayString(_ctx.formattedTime), 1)
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.secret), 1),
    _createVNode(BasePillButton, {
      class: "verify-button",
      disabled: copied.value,
      onClick: copyToClipboard
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(copyText.value), 1)
      ], undefined, true),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((verificationCode).value = $event)),
      type: "number",
      class: "mfa-code-input display-text",
      placeholder: "Your 6 digit code"
    }, null, 512), [
      [_vModelText, verificationCode.value]
    ]),
    _createVNode(BasePillButton, {
      class: "verify-button",
      label: "Verify MFA",
      disabled: !enteredCode.value || _ctx.isVerifying,
      onClick: verifyMFA
    }, {
      default: _withCtx(() => [
        (_ctx.isVerifying)
          ? (_openBlock(), _createBlock(SimpleSpinner, {
              key: 0,
              size: "tiny",
              "line-bg-color": "transparent",
              "line-fg-color": _ctx.$palette.brandPurple
            }, null, 8, ["line-fg-color"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Verify MFA")
            ], 64))
      ], undefined, true),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})